import { Locale } from 'modules/i18n';

export const addToProjectMenuItemTranslation = {
  [Locale.en]: {
    addToProject: 'Add to project',
  },
};
